import CompleteTemplate from './presets/CompleteTemplate'
import MinimalTemplate from './presets/MinimalTemplate'

export const HORIZONTAL_TEMPLATE = 'Template horizontal'
export const VERTICAL_TEMPLATE = 'Template vertical'

export const TEMPLATES_AVAILABLE = {
  [HORIZONTAL_TEMPLATE]: {
    templateWidth: 16,
    Component: CompleteTemplate,
    logoSize: 2.2
  },

  [VERTICAL_TEMPLATE]: {
    templateWidth: 6,
    Component: MinimalTemplate,
    logoSize: 1.7
  }
}
